/**
 * CreditHold enforcement permissions — distinct from advisory collection_credit_hold:*.
 */

export const CREDIT_HOLD_READ_PERMISSION = 'credit_hold:read' as const;
export const CREDIT_HOLD_CREATE_PERMISSION = 'credit_hold:create' as const;
export const CREDIT_HOLD_APPROVE_PERMISSION = 'credit_hold:approve' as const;
export const CREDIT_HOLD_RELEASE_PERMISSION = 'credit_hold:release' as const;

export const CREDIT_HOLD_PERMISSIONS = [
  CREDIT_HOLD_READ_PERMISSION,
  CREDIT_HOLD_CREATE_PERMISSION,
  CREDIT_HOLD_APPROVE_PERMISSION,
  CREDIT_HOLD_RELEASE_PERMISSION,
] as const;

export type CreditHoldPermission = (typeof CREDIT_HOLD_PERMISSIONS)[number];

export function isCreditHoldPermission(permission: string): permission is CreditHoldPermission {
  return (CREDIT_HOLD_PERMISSIONS as readonly string[]).includes(permission);
}
